import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Apple } from 'lucide-react';

const MobileRedirect = ({ user }) => {
  const [redirecting, setRedirecting] = useState(true);
  const navigate = useNavigate();
  
  useEffect(() => {
    // Check if user is on iOS (iPhone, iPad, iPod)
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    
    if (isIOS) {
      // Try to open the app first using the custom URL scheme
      const appScheme = 'spiel://';
      const appStoreLink = 'https://apps.apple.com/us/app/spiel-your-life-as-a-sitcom/id6744564558';
      
      // Create an invisible iframe to try opening the app
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = appScheme;
      document.body.appendChild(iframe);
      
      // Set a timeout to redirect to App Store if app doesn't open
      setTimeout(() => {
        window.location.href = appStoreLink;
      }, 500);
    } else {
      // For non-iOS mobile devices, just show the message
      setRedirecting(false);
    }
    
    // If user is on desktop, redirect back to home
    if (!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
      navigate('/');
    }
  }, [navigate]);
  
  if (redirecting) {
    return (
      <div style={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#1a1a1a',
        padding: '2rem'
      }}>
        <div style={{
          width: '60px',
          height: '60px',
          borderRadius: '50%',
          border: '3px solid #6600CC',
          borderTopColor: 'transparent',
          animation: 'spin 1s linear infinite'
        }} />
        <p style={{
          color: 'white',
          marginTop: '1.5rem',
          fontSize: '1.1rem',
          textAlign: 'center'
        }}>
          Redirecting to Spiel app...
        </p>
        <style>{`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }
  
  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#1a1a1a',
      padding: '2rem'
    }}>
      <div style={{
        backgroundColor: '#6600CC',
        borderRadius: '1rem',
        padding: '2rem',
        maxWidth: '500px',
        width: '90%',
        textAlign: 'center',
        boxShadow: '0 10px 25px rgba(0, 0, 0, 0.3)'
      }}>
        <h1 style={{
          color: 'white',
          fontSize: '1.8rem',
          marginBottom: '1.5rem'
        }}>
          Spiel is not available on this device
        </h1>
        
        <p style={{
          color: 'white',
          fontSize: '1.1rem',
          lineHeight: 1.5,
          marginBottom: '2rem'
        }}>
          Spiel is available on desktop browsers and on the Apple App Store for iPhone users.
        </p>
        
        <a 
          href="https://apps.apple.com/us/app/spiel-your-life-as-a-sitcom/id6744564558"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.75rem',
            backgroundColor: 'black',
            color: 'white',
            padding: '1rem 1.5rem',
            borderRadius: '0.5rem',
            textDecoration: 'none',
            fontWeight: 'bold',
            margin: '0 auto',
            maxWidth: '250px'
          }}
        >
          <Apple size={24} />
          <span>Download on iOS</span>
        </a>
      </div>
    </div>
  );
};

export default MobileRedirect; 